export enum StorageKeys {
    DebuggerActive = "debugger-active",
}
